// @ts-ignore
import Swiper from 'swiper';
// @ts-ignore
import {Navigation, Pagination, Autoplay} from 'swiper/modules';

export class TeaserSlider {
  private main: HTMLElement;

  constructor(container: HTMLElement) {
    this.main = container.querySelector('[data-teaser-slider-main]');

    if (!this.main) {
      console.warn('Necessary components missing for teaser slider.');
      return;
    }

    new Swiper(this.main, {
      loop: true,
      spaceBetween: 0,
      navigation: {
        nextEl: this.main.querySelector('.swiper-button-next'),
        prevEl: this.main.querySelector('.swiper-button-prev'),
        addIcons: false,
      },
      pagination: {
        el: this.main.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: true,
      },
      autoplay: {
        delay: 5000,
      },
      modules: [Navigation, Pagination, Autoplay],
    });
  }
}

document.querySelectorAll('[data-teaser-slider]').forEach((el) => {
  new TeaserSlider(el as HTMLElement);
});
